<template>
  <div class="page-error-layout">
    <div class="content">
      <img class="img"
           :class="{ 'page-404': type === 404 }"
           :src="img"
           alt="Error Image"
      >
      <p class="desc" v-html="desc"></p>
      <div class="action"
           :class="{ 'flex-center': !showGOBack }"
      >
        <ym-button class="btn"
                   type="primary"
                   v-if="showGOBack"
                   @click="handleGoBack"
        >
          返回上一页
        </ym-button>
        <ym-button class="btn"
                   type="primary"
                   plain
                   @click="handleGoHome"
        >
          返回首页
        </ym-button>
      </div>
    </div>
  </div>
</template>

<script>
  import { Button } from 'ym-mint-ui';
  import { TimePool } from '@/utils/timer';

  export default {
    name: 'ErrorLayout',
    components: {
      'ym-button': Button,
    },
    data() {
      return {
        duration: 6,
        interval: new TimePool().getTimer(1000),
        intervalIndex: -1,
      };
    },
    computed: {
      showGOBack() {
        return window.history.length > 2;
      },
    },
    props: {
      img: {
        type: String,
      },
      desc: {
        type: String,
      },
      type: {
        type: Number,
      },
    },
    methods: {
      handleGoHome() {
        this.$router.replace({ name: 'Home' });
      },
      handleGoBack() {
        this.$router.go(-1);
      },
    },
    destroyed() {
      this.interval.remove(this.intervalIndex);
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-error-layout {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: @color-white;
  }

  .content {
    position: absolute;
    top: 20%;
    left: 0;
    right: 0;
    padding: 0 @size-base;
  }

  .img {
    display: block;
    width: 80%;
    margin: 0 auto @size-base;
    &.page-404 {
      width: 324px;
    }
  }

  .desc {
    color: @color-text-lighter;
    font-size: @font-size-medium;
    text-align: center;
    margin: 0 auto @size-medium;
  }

  .action {
    padding: 0 100px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: @color-text-light;
    max-width: 750px;
    margin: 0 auto;
    box-sizing: border-box;
    &.flex-center {
      justify-content: center;
    }
  }

  .btn {
    border-radius: 35px;
    font-size: inherit;
  }
</style>
